import { useTranslation } from "react-i18next";
import React, { useState, Fragment } from "react";
import ResponsiveDialog from "../shared/components/ResponsiveDialog";
import { ListItemButton, TextField } from "@mui/material";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItemText from "@mui/material/ListItemText";

import { useZulassung } from "../../context/zulassungs-context";

function MandantenAuswahl({ onClick, program, open, setOpen }) {
  const { t } = useTranslation();
  const { zulassung, updateMandant } = useZulassung();
  const [mandantenSuche, setMandantenSuche] = useState("");

  const handleMandantenClick = (mandant) => {
    setOpen(false);
    updateMandant(mandant.key);
    if (typeof onClick === "function") {
      onClick();
    }
  };
  const displayMandantenSuche = () => {
    const tmpPgm = zulassung.programs.find((pgm) => {
      return pgm.prg === program;
    });

    if (tmpPgm?.mandanten?.length < 5) {
      return null;
    } else {
      return (
        <TextField
          label="Mandantensuche"
          value={mandantenSuche}
          onChange={(e) => setMandantenSuche(e.target.value)}
          variant="outlined"
          fullWidth
          margin="normal"
        />
      );
    }
  };

  const displayClientList = () => {
    const tmpPgm = zulassung.programs.find((pgm) => {
      return pgm.prg === program;
    });

    const displayClients =tmpPgm?.mandanten
  ?.filter((dataObject) => {
    const name = dataObject.name.toLowerCase();
    const vkey = dataObject.vkey.toLowerCase();
    const searchQuery = mandantenSuche.toLowerCase();
    return name.includes(searchQuery) || vkey.includes(searchQuery);
  })
  ?.map((dataObject) => {
      const name = dataObject.name;
      return (
        <Fragment key={dataObject.key}>
          <Divider component="li" light />
          <ListItemButton key={dataObject.key} onClick={() => handleMandantenClick(dataObject)}>
            <ListItemText primary={name} secondary={dataObject.vkey} />
          </ListItemButton>
        </Fragment>
      );
    });
    return displayClients;
  };

  return (
    <ResponsiveDialog title={t("Mandantenauswahl")}open={open} setOpen={setOpen} >
      {displayMandantenSuche()}
      
      <List sx={{overflow:"auto"}}>{displayClientList()}</List>
    </ResponsiveDialog>
  );
}
export default MandantenAuswahl;
